import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./reducers/authReducer"
import Alert from "./reducers/alertReducer"
import Shared from "./reducers/sharedReducer"
import Roles from "./reducers/rolesReducer"
import Customers from "./reducers/customersReducer"
import Users from "./reducers/usersReducer"
import Branchs from "./reducers/branchsReducer"
import Banners from "./reducers/bannersReducer"
import Categories from "./reducers/categoriesReducer"
import Items from "./reducers/itemsReducer"
import ItemGroups from "./reducers/itemGroupsReducer"
import ModifierGroups from "./reducers/modifierGroupReducer"
import Modifiers from "./reducers/modiferReducer"
import Countries from "./reducers/countriesReducer"
import Region from "./reducers/regionReducer"
import City from "./reducers/cityReducer"
import Allergens from "./reducers/allergensReducer"
import Ingredients from "./reducers/ingredientsReducer"
import Common from "./reducers/commonReducer"
import Orders from "./reducers/orderReducer"
import Tax from "./reducers/taxReducer"
import Dashboard from "./reducers/dashboardReducer"
import APILogs from "./reducers/apiLogsReducer"
import Ratings from "./reducers/ratingReducer"
import Promotions from "./reducers/promotionsReducer"
import GlobalSettings from "./reducers/globalSettingReducer"
import PushNotifications from "./reducers/pushNotificationReducer"
import CustomerSupport from "./reducers/customerSupportReducer"
import Reports from "./reducers/reportsReducer"
import Faqs from "./reducers/faqReducer"
import Bookings from "./reducers/bookingsReducer"
import POS from "./reducers/posReducer"
import Vehicles from "./reducers/vehicleReducer"
import GiftCard from "./reducers/giftCardReducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Alert,
  Shared,
  Login,
  Roles,
  Customers,
  Users,
  Banners,
  Branchs,
  Categories,
  Items,
  ItemGroups,
  ModifierGroups,
  Modifiers,
  Countries,
  Region,
  City,
  Allergens,
  Ingredients,
  Common,
  Orders,
  Tax,
  Dashboard,
  APILogs,
  Ratings,
  Promotions,
  GlobalSettings,
  PushNotifications,
  CustomerSupport,
  Reports,
  Faqs,
  Bookings,
  POS,
  Vehicles,
  GiftCard,
})

export default rootReducer
